<div class="col-12">
  <p-divider align="center">
    <span class="p-tag">{{'Atf' | translate}}</span>
  </p-divider>
  @if (isLock === false && atfActions.atfAllowAddFile === true && editMode === true) {
    <div
      (click)="$event.stopPropagation()"
      >
      <div class="my-drop-zone" [ngxDragAndDrop]="options" *ngxInputFile>
        <div class="drag-text">{{'File_Add' | translate}}</div>
      </div>
    </div>
  }
  <table class="table head" style="font-size: 14px;">
    <thead>
      <tr>
        <th width="50%">{{'File' | translate}}</th>
        <th width="20%">{{'Date' | translate}}</th>
        <th>{{'Action' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (atfFile of listAtf; track atfFile.name; let i = $index) {
        <tr>
          <td class="word-break-all">
            {{ atfFile.name }}
          </td>
          <td>
            @if (atfFile.ModifiedOn !== undefined) {
              <span>
                {{ atfFile.ModifiedOn | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
            }
          </td>
          @if (editMode === true) {
            <td style="text-align: right;">
              @if (isLock === false && atfFile.visu === true) {
                <i
                  data-icons8="&#xf150;"
                  class="margin-right iconstyle"
                  pTooltip="{{'View' | translate}}"
                  (click)="Show_PJ(atfFile)"
                  style="color: black;"
                ></i>
              }              
              @if (isLock === false && atfFile.allowTrs === true) {
                <i
                  class="icons8-send-package-2 margin-right iconstyle"
                  pTooltip="{{'Atf_Trans' | translate}}"
                  (click)="transAtfFileBsk(atfFile)"
                  style="color: black;"
                ></i>
              }
              @if (
                isLock === false &&
                atfActions.atfAllowConvertPdf === true &&
                atfFile.Extension !== '.pdf' &&
                atfFile.Extension !== '' &&
                atfFile.allowCnv === true
                ) {
                <i
                  class="icons8-update-file margin-right iconstyle"
                  pTooltip="{{'Convert' | translate}}"
                  (click)="convertAtfFile(atfFile)"
                  style="color: black;"
                ></i>
              }
              @if (isLock === false && atfActions.atfAllowRename === true) {
                <i
                  class="icons8-rebaptiser margin-right iconstyle"
                  pTooltip="{{'Ren' | translate}}"
                  (click)="renameAtfFile(atfFile)"
                  style="color: black;"
                ></i>
              }
              @if (atfActions.atfAllowSaveAs === true && atfFile.allowTrs) {
                <i
                  class="icons8-t-l-charger margin-right iconstyle"
                  pTooltip="{{'DwnL' | translate}}"
                  (click)="downloadAtfFile(atfFile)"
                  style="color: black;"
                ></i>
              }
              @if (isLock === false && atfActions.atfAllowDelete === true) {
                <i
                  class="icons8-trash-can margin-right iconstyle"
                  pTooltip="{{'Delete' | translate}}"
                  (click)="removeAtfFile(atfFile)"
                  style="color: red;"
                ></i>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

<form #uploadForm="ngForm">
  <addbasefile
    [visible]="displayUpload"
    [displayStopValue]="displayStop"
    [uploader]="uploader"
    [title]="'Atf_Add' | translate"
    [dataLabel]="docName"
    [bskType]=""
    [bskDocAddList]="[]"
    [ctrlDouble]="ctrlDouble"
    [enterVariable]="false"
    [requiredVariable]="false"
    [fileMode]="false"
    [disabledSend]="false"
    (onClose)="close($event)"
    (onClickAdd)="onClickAdd($event)"
    (onClickStop)="onClickStop($event)"
    (onRemoveItem)="removeItem($event)"
  ></addbasefile>
</form>

<app-item-confirm [key]="'deleteatf'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
<app-item-confirm [key]="'convertatf'" [severity]="'alert'" (onAccept)="convert($event)"></app-item-confirm>

<p-dialog
  [contentStyle]="{ overflow: 'auto' }"
  [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'"
  [(visible)]="displayRename"
  [dismissableMask]="false"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  (onHide)="closeRename()"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Ren_Atf_1' | translate}}
    </span>
  </ng-template>

  @if (atfActions.atfAllowPrefixList === true) {
    <div class="col-12">
      <inputvalue
        [visuMode]="false"
        [title]="'Pref_B' | translate"
        [dataVariableList]="listComboPrefix"
        [libAction]="false"
        [editorService]="editorService"
      ></inputvalue>
    </div>
  }

  <div class="col-12">
    <input [(ngModel)]="atfName" class="p-inputtext size_cent" pInputText type="text" maxlength="64" autofocus />
  </div>
  <div class="col-12 md:col-12 align-right">
    <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeRename()" label="{{'Cancel' | translate}}"></button>
    <button type="button" pButton class="margin" (click)="onClickRenameAtf()" label="{{'Save' | translate}}"></button>
  </div>
</p-dialog>

<p-dialog [(visible)]="showThumb" [header]="thumbName" position="top-right" [closable]="true" [modal]="true" showHeader="true"
  appendTo="body">
  @if (showThumbImg === true) {
    <img
      class="cursorPointer"
      style="width: 30vw"
      [src]="thumbs | safe"
      />
  }
  @if (showThumbPdf === true) {
    <div style="width: 30vw">
      <atf-view
        [atfName]="thumbName"
        [docId]="docId"
        [stylePdf]='"width: 100%; height: 80vh;"'
      ></atf-view>
    </div>    
  }
</p-dialog>

